import * as React from "react"

type NavigationContextType = {
  isLoggedIn: boolean
  deepLink: null | string
  deepLinkHandled: boolean
  setDeepLink: (newValue: null | string) => void
  setDeepLinkHandled: (newValue: boolean) => void
  /** Latest handled flag, including updates that have not re-rendered yet. */
  getDeepLinkHandled: () => boolean
  setIsLoggedIn: (newValue: boolean) => void
  initLinkHandled: boolean
  setInitLinkHandled: (newValue: boolean) => void
}

export const NavigationContext = React.createContext<NavigationContextType>({
  isLoggedIn: false,
  setIsLoggedIn: () => undefined,
  deepLink: null,
  setDeepLink: () => void 0,
  deepLinkHandled: false,
  setDeepLinkHandled: () => false,
  getDeepLinkHandled: () => false,
  initLinkHandled: false,
  setInitLinkHandled: () => false,
})
